import type { DialogCloseButtonProps } from './dialog.types'

import { styled, useStyleConfig, vui } from '../core'
import { DismissButton } from '../dismissButton'
import { cs } from '../utils'
import { useDialogContext } from './context'

const StyledDismissButton = styled(DismissButton)<{ $dismissFg?: string }>`
  ${({ $dismissFg }) => $dismissFg && `--vui-dismiss-fg: ${$dismissFg};`}
`

/** Shows a CloseButton in the Dialog Header, which by default closes the Dialog. */
export const DialogCloseButton = vui<'button', DialogCloseButtonProps>((props, ref) => {
  const { className, size = 'md', ...rest } = props
  const { onClose } = useDialogContext() ?? {}
  const styles = useStyleConfig('Dialog', useDialogContext())

  return (
    <StyledDismissButton
      className={cs('vui-dialogCloseButton', className)}
      onClick={onClose}
      position="absolute"
      ref={ref}
      right={16}
      size={size}
      top={16}
      $dismissFg={styles.closeButton?.['--vui-dismiss-fg']}
      {...styles.closeButton}
      {...rest}
    />
  )
})

DialogCloseButton.displayName = 'DialogCloseButton'

export default DialogCloseButton
